export default [
  {
    path: '/customer-satisfaction',
    name: 'customer-satisfaction',
    component: () => import('@/views/customerSatification/View.vue'),
    meta: {
      pageTitle: 'breadcrumb.customerSatification',
      navActiveLink: 'customer-satisfaction',
      resource: ['report-customer-satisfaction', 'report-call-satisfaction'],
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.customerSatification',
          active: true,
        },
      ],
    },
  },
]
